import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import StopwatchIcon from '@atlaskit/icon/core/stopwatch';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.time-spent-field.icon-label',
		defaultMessage: 'Time spent field',
		description:
			'Accessible label for the icon representing the time spent field in a Jira work item action card.',
	},
});

export const TimeSpentFieldIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<StopwatchIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
};
